import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { Container, Row, Col } from "react-bootstrap";
import * as ROUTES from "../../constans/rutas";
import logo from "../../asses/img/parkingl.png";
import Button from "react-bootstrap/Button";
import { FaHome } from "react-icons/fa";
import { toast } from "react-toastify";
import Files from "./file";
import axios from "axios";
import { URL_EMPLOYEE } from "../../constans/servidor";

const CreditNotes = () => {
  const history = useHistory();
  const [name, setName] = useState();
  const [archivos, setUrl] = useState();
  const [showLoading, setShowLoading] = useState(false);

  const uploadData = async (e) => {
    e.preventDefault();
    setShowLoading(true);
    if (!name) {
      setShowLoading(false);
      toast.error("Todos los campos son obligatorios", "danger");
      return;
    }
    if (name) {
      const payload = name.map((fileName, index) => ({
        name: fileName.name,
      }));

      try {
        const result = await axios.post(
          `${URL_EMPLOYEE}/noteCredit/getUploadExcel`,
          { name: payload[0].name }
        );

        if (result.data.status) {
          try {
            for (let i = 0; i < name.length; i++) {
              const file = name[i];
              const url = result.data.data;

              const fileContent = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.readAsArrayBuffer(file);
              });

              let blobData = new Blob([fileContent], {
                type: "application/pdf",
              });

              await axios.put(url, blobData, {
                headers: {
                  "Access-Control-Allow-Origin": "*",
                },
              });
              toast.success(
                `Archivo ${file.name} cargado con éxito!`,
                "success"
              );
              setShowLoading(false);
            }
            setName([]);
          } catch (error) {
            setShowLoading(false);
            console.log(error.message);
            toast.error("Hubo un error al cargar el archivo", "danger");
          }
        } else {
          toast.error(result.data.message);
          setShowLoading(false);
        }
      } catch (error) {
        setShowLoading(false);
        console.log(error.message);
        toast.error("Hubo un error al cargar el archivo", "danger");
      }
    }
  };

  return (
    <>
      <Container className="contendor-Principal">
        <Row>
          <Col className="cont_logo" xs={12} sm={12} md={12} lg={12} xl={12}>
            <img className="logo" src={logo}></img>
            <p className="texto-slogan">Gestion de Notas Crédito</p>
          </Col>
        </Row>
        <Row className="justify-content-end ">
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "15px",
            }}
            className="cont_logo"
            xs={12}
            sm={12}
            md={6}
            lg={4}
            xl={4}
          >
            <Button
              style={{ marginRight: "10px" }}
              variant="primary"
              onClick={() => history.push(ROUTES.HOME)}
            >
              <FaHome size={20} style={{ marginRight: "5px" }} />
              HOME
            </Button>
          </Col>
        </Row>
        <Row className="justify-content-center mbottom-20 menu">
          <Col
            className={window === 1 ? "menu_items2" : "menu_items"}
            xs={2}
            sm={2}
            md={2}
            lg={2}
            xl={2}
          >
            <Files
              className="container-file"
              archivo={archivos}
              value={name}
              onChange={(e) => setName(e)}
              setName={setName}
              isNameEmpty={name}
            />
            {showLoading ? (
              <div className="container-sniper mt-3"></div>
            ) : (
              <button className="mt-3" onClick={uploadData}>
                Cargar
              </button>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreditNotes;
